module.exports = __webpack_public_path__ + "img/zoho.d6750894.png";